<script>
export default {
  data() {
    return {
      filterText: ''
    }
  },
  methods: {
    doFilter() {
      this.$emit('filter', this.filterText)
    }
  }
}
</script>
<style>
  .search {
    width: 300px;
  }
</style>
<template>
  <div class="field is-grouped">
    <p class="control is-expanded has-addons">
      <input class="input search" type="text" v-model="filterText" @keyup.enter="doFilter" placeholder="Search...">
      <a @click="doFilter" class="button is-primary">Go</a>
    </p>
    <slot></slot>
  </div>
</template>